module.exports = __webpack_public_path__ + "img/goods16-1.e9eed451.jpg";